module.exports = "/_next/static/images/Introduction@2x-1e1361e39efea6fa719ba67d3236a7ed.webp";